import { ACTIVE_PAYMENT_MODES, DELIVERY_ADDRESS, EXTRA_ADDRESS, GEOCODED_ADDRESS, ORDER, ORDER_LATER_DATETIME, ORDER_TIME, ORDER_TYPE, PAYMENT, PAYMENT_METHOD, PICKUP_TIME, SAVE_HBL_BANK_DATA, SET_POSITION, SET_SEARCH_STRING, SET_TAX } from "../actions/paymentTypes";


const initialState: any = {
  orderType: process.env.REACT_APP_DELIVERY_ENABLE == "true" ? "Delivery" : "Pickup",
  orderTime: "now",
  orderLaterDateTime: null,
  paymentMethod: "",
  successFlag: false,
  order_id: "",
  hblFormData: [] || "",
  payment_modes: [] || "",
  pickupTime: 15,
  delivery_address: null,
  geocoded_address: null,
  extra_address: null,
  position: null,
  searchString: "",
  payment_tax: false
}
const paymentReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ORDER_TYPE:
      return {
        ...state,
        orderType: action.orderType,
      };
    case ORDER_TIME:
      return {
        ...state,
        orderTime: action.orderTime,
      };
    case ORDER_LATER_DATETIME:
      return {
        ...state,
        orderLaterDateTime: action.dateTime,
      };
    case PAYMENT_METHOD:
      return {
        ...state,
        paymentMethod: action.paymentMethod,
      };
    case PAYMENT:
      return {
        ...state,
        successFlag: action.successFlag
      };
    case ORDER:
      return {
        ...state,
        order_id: action.order_id,
      };
    case DELIVERY_ADDRESS:
      return {
        ...state,
        delivery_address: action.payload
      }
    case GEOCODED_ADDRESS:
      return {
        ...state,
        geocoded_address: action.payload
      }
    case EXTRA_ADDRESS:
      return {
        ...state,
        extra_address: action.payload
      }
    case SAVE_HBL_BANK_DATA:
      return {
        ...state,
        hblFormData: action.payload
      }
    case ACTIVE_PAYMENT_MODES:
      return {
        ...state,
        payment_modes: action.payload
      }
    case PICKUP_TIME:
      return {
        ...state,
        pickupTime: action.time
      }
    case SET_POSITION:
      return {
        ...state,
        position: action.position
      }
    case SET_TAX:
      return {
        ...state,
        payment_tax: action.payload
      }
    case SET_SEARCH_STRING:
      return {
        ...state,
        searchString: action.searchString
      }
    default: return state;
  }
}
export default paymentReducer;